import React from 'react'
import lodash from 'lodash'
import TimestampText from './TimestampText'

const TimestampField = ({ source, record = {} }) => {
  return <TimestampText time={lodash.get(record, source)} />
}

export default TimestampField
